import React from "react";
import Lowarrow from "../../../asset/images/low-arrow.svg";
import UpArrow from "../../../asset/images/up-arrow.svg";
import { Constants } from "../../../CommonMethhods/Constants";
import {
  forToFix,
  numDifferentiationWithoutSymbol,
} from "../../../CommonMethhods/CovertRupees";
import SmallLoader from "../../Common/smallLoader";

function AumSnapshot(props) {
  const revenueTable = props.revenueTableData;
  const yesterday = revenueTable.yesterday;
  const weekly = revenueTable.weekly;
  const month = revenueTable.monthly;
  const year = revenueTable.yearly;

  const rowLabels = ["Equity", "F&O", "Total"];
  const handleifTableEmpty = (flag) => {
    const tempArray = [
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ];

    return tempArray.map((column, index) => {
      return (
        <tr key={index}>
          {flag === true ? (
            <th className="text-left header-width">{rowLabels[index]}</th>
          ) : (
            <></>
          )}
          {column.map((index) => {
            return (
              <td key={index} className="snapshot-table-column">
                {"0"}
              </td>
            );
          })}
        </tr>
      );
    });
  };

  const generateOverallTableData = (rows, flag) => {
    return Object.keys(rows).map((column, index) => {
      const columnValues = rows[column];
      rows[column].revenue = rows[column].revenue || 0;
      rows[column].saleExist = rows[column].saleExist || 0;
      rows[column].chg = rows[column].chg || 0;
      rows[column].chgper = forToFix(rows[column].chgper) || 0;

      // rows[column].chgper=  rows[column].chgper.toFixed(2) || (rows[column].chgper).toFixed(2) ;

      return (
        <tr key={index} className="snapshot-table-row">
          {flag == true ? (
            <th className="text-left header-width"> {rowLabels[index]}</th>
          ) : (
            <></>
          )}
          <td key={index} className="snapshot-table-column overall-aum">
            <>
              <img
                src={
                  columnValues.chg === 0
                    ? ""
                    : columnValues.chg < 0
                    ? Lowarrow
                    : UpArrow
                }
                alt=""
              />
              <>
                {columnValues.revenue == undefined || null
                  ? "0"
                  : numDifferentiationWithoutSymbol(columnValues.revenue, 1)}
              </>
            </>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.saleExist == 0
                  ? "text-muted"
                  : columnValues.saleExist < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.saleExist == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.saleExist)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chg == 0
                  ? "text-muted"
                  : columnValues.chg < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.chg == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.chg)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chgper == 0
                  ? "text-muted"
                  : columnValues.chgper < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.chgper == undefined || null
                ? "0"
                : columnValues.chgper}{" "}
              %
            </span>
          </td>
        </tr>
      );
    });
  };

  //handle data
  const generateSnapshotTableData = (rows, flag) => {
    return Object.keys(rows).map((column, index) => {
      const columnValues = rows[column];
      rows[column].revenue = rows[column].sale || 0;
      rows[column].saleExist = rows[column].saleExist || 0;
      rows[column].chg = rows[column].chg || 0;
      rows[column].chgper = forToFix(rows[column].chgper) || 0;

      // rows[column].chgper=  rows[column].chgper.toFixed(2) || (rows[column].chgper).toFixed(2) ;

      return (
        <tr key={index} className="snapshot-table-row">
          {flag === true ? (
            <th className="text-left header-width"> {rowLabels[index]}</th>
          ) : (
            <></>
          )}

          <td className="snapshot-table-column overall-aum">
            <>
              <img
                src={
                  columnValues.chg === 0
                    ? ""
                    : columnValues.chg < 0
                    ? Lowarrow
                    : UpArrow
                }
                alt=""
              />
              <>
                {/* <a
                  className="overall-revenue"
                  onClick={() => handleViewClick(column, "Overall")}
                > */}
                {columnValues.sale === undefined || null
                  ? "0"
                  : numDifferentiationWithoutSymbol(columnValues.sale)}
                {/* </a> */}
              </>
            </>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.saleExist === 0
                  ? "text-muted"
                  : columnValues.saleExist < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.saleExist === undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.saleExist)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chg === 0
                  ? "text-muted"
                  : columnValues.chg < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.chg === undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.chg)}
            </span>
          </td>
          {/* <br /> */}
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chgper === 0
                  ? "text-muted"
                  : columnValues.chgper < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.chgper === undefined || null
                ? "0"
                : columnValues.chgper}{" "}
              %
            </span>
          </td>
        </tr>
      );
    });
  };

  const handleFileType = (e) => {
    if (e.target.value) {
      props.handleOnClickSnapFileType(e.target.value, "Sales");
    }
  };

  return (
    <div className="snapshot-detail-block revenue-detail aum-report">
      <div className="card-title mb-0">
        <h2>{props.title}</h2>
        <div className="generate-btn-wrapper mt-0">
          <button
            className="generate-btn excel1 text-green"
            value="excel"
            onClick={(e) => handleFileType(e)}
          >
            {props?.buttonLoader?.excel ? (
              <SmallLoader />
            ) : (
              <>
                <span className="icon-excelsvg"></span>
                Excel
              </>
            )}
          </button>
          <button
            className="generate-btn pdf1 txt-purple"
            value="pdf"
            onClick={(e) => handleFileType(e)}
          >
            {props?.buttonLoader?.pdf ? (
              <SmallLoader />
            ) : (
              <>
                <span className="icon-pdfsvg"></span> PDF
              </>
            )}
          </button>
        </div>
      </div>

      <div className="snapshot-table scroll-table">
        <table className="table tabel-level1">
          <tr className="for-gap">
            <td className="for-width">
              <table className="table table-level2">
                <thead>
                  <tr>
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center"
                    >
                      {Constants.Yesterday}

                      <br />
                      <span>{Constants.Compare_Yesterday}</span>
                    </th>
                  </tr>
                  <tr>
                    <th scope="col" className="header-width"></th>
                    <th scope="col">Sales</th>
                    <th scope="col">{Constants.Previous}</th>
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {yesterday == null || undefined
                    ? handleifTableEmpty(true)
                    : generateOverallTableData(yesterday, true)}
                </tbody>
              </table>
            </td>
            <td>
              <table className="table table-level3">
                <thead>
                  <tr>
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center"
                    >
                      {Constants.Current_Week}
                      <br />
                      <span>{Constants.Compare_Week}</span>
                    </th>
                  </tr>
                  <tr>
                    <th scope="col">Sales</th>
                    <th scope="col">{Constants.Previous}</th>

                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {weekly == null || undefined
                    ? handleifTableEmpty()
                    : generateSnapshotTableData(weekly, "Weekly")}
                </tbody>
              </table>
            </td>
            <td>
              <table className="table table-level4">
                <thead>
                  <tr>
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center"
                    >
                      {Constants.Current_Month}
                      <br />
                      <span>{Constants.Compare_Month}</span>
                    </th>
                  </tr>
                  <tr>
                    <th scope="col">Sales</th>
                    <th scope="col">{Constants.Previous}</th>

                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {month == null || undefined
                    ? handleifTableEmpty()
                    : generateSnapshotTableData(month, "Monthly")}
                </tbody>
              </table>
            </td>
            <td>
              <table className="table table-level5">
                <thead>
                  <tr>
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center"
                    >
                      {Constants.Current_Year}
                      <br />
                      <span>{Constants.Compare_Year}</span>
                    </th>
                  </tr>
                  <tr>
                    <th scope="col">Sales</th>
                    <th scope="col">{Constants.Previous}</th>

                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {year == null || undefined
                    ? handleifTableEmpty()
                    : generateSnapshotTableData(year, "Yearly")}
                </tbody>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
}

export default React.memo(AumSnapshot);
